import { render } from "./TextRefSelect.vue?vue&type=template&id=456f8677&scoped=true"
import script from "./TextRefSelect.vue?vue&type=script&lang=js"
export * from "./TextRefSelect.vue?vue&type=script&lang=js"

import "./TextRefSelect.vue?vue&type=style&index=0&id=456f8677&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456f8677"]])

export default __exports__